import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import isEmailValid from '../../../../../utils/isEmailValid';
import { EmailsObjectType } from '../../types';

export default function useRoutingNoResultEmails() {
  const [addRoutingNoResultEmailModalShow, setAddRoutingNoResultEmailModalShow] = useState(false);
  const [removeRoutingNoResultEmailModalShow, setRemoveRoutingNoResultEmailModalShow] = useState(false);
  const [routingNoResultEmails, setRoutingNoResultEmails] = useState<EmailsObjectType[]>([]);
  const [routingNoResultEmailToAdd, setRoutingNoResultEmailToAdd] = useState('');
  const [routingNoResultEmailToRemove, setRoutingNoResultEmailToRemove] = useState('');
  const [originalRoutingNoResultEmails, setOriginalRoutingNoResultEmails] = useState<EmailsObjectType[]>([]);
  const [routingNoResultEmailOwnerNameToAdd, setRoutingNoResultEmailOwnerNameToAdd] = useState('');

  const hasOriginalRoutingNoResultEmailsChanged = useMemo((() => JSON.stringify(originalRoutingNoResultEmails) !== JSON.stringify(routingNoResultEmails)), [originalRoutingNoResultEmails, routingNoResultEmails]);
  const hasRoutingNoResultEmailsToBeRendered = useMemo((() => routingNoResultEmails.length > 0), [routingNoResultEmails]);

  function handleRoutingNoResultEmailToAddChange(event: ChangeEvent<HTMLInputElement>) {
    setRoutingNoResultEmailToAdd(event.target.value);
  }

  function handleRoutingNoResultEmailOwnerNameToAddChange(event: ChangeEvent<HTMLInputElement>) {
    setRoutingNoResultEmailOwnerNameToAdd(event.target.value);
  }

  const addRoutingNoResultEmail = useCallback(() => {
    const onlyEmails = routingNoResultEmails.map((emailObj) => emailObj.email);
    const doesEmailAlreadyExists = onlyEmails.includes(routingNoResultEmailToAdd);
    if (doesEmailAlreadyExists) {
      toast.warn('Este e-mail já foi adicionado!');
      return;
    }
    if (!isEmailValid(routingNoResultEmailToAdd)) {
      toast.warn('E-mail inválido!');
      return;
    }
    setRoutingNoResultEmails((prevState) => [...prevState, { email: routingNoResultEmailToAdd, emailOwnerName: routingNoResultEmailOwnerNameToAdd }]);
    setRoutingNoResultEmailToAdd('');
    toast.success('E-mail adicionado. Não se esqueça de salvar as alterações para confirmar');
  }, [routingNoResultEmailOwnerNameToAdd, routingNoResultEmailToAdd, routingNoResultEmails]);

  const removeRoutingNoResultEmail = useCallback(() => {
    const filteredEmails = routingNoResultEmails.filter((email) => email.email !== routingNoResultEmailToRemove);
    setRoutingNoResultEmails(filteredEmails);
    setRemoveRoutingNoResultEmailModalShow(false);
    toast.success('E-mail removido. Não esqueça de salvar as configurações para aplicar as mudanças!');
    setRoutingNoResultEmailToRemove('');
    setRoutingNoResultEmailOwnerNameToAdd('');
  }, [routingNoResultEmailToRemove, routingNoResultEmails]);

  const resetRoutingNoResultEmails = useCallback(() => {
    setRoutingNoResultEmails(originalRoutingNoResultEmails);
    toast.info('Suas alterações foram desfeitas');
  }, [originalRoutingNoResultEmails]);

  return {
    setAddRoutingNoResultEmailModalShow,
    hasRoutingNoResultEmailsToBeRendered,
    routingNoResultEmails,
    setRoutingNoResultEmailToRemove,
    setRemoveRoutingNoResultEmailModalShow,
    routingNoResultEmailToRemove,
    removeRoutingNoResultEmail,
    addRoutingNoResultEmailModalShow,
    routingNoResultEmailToAdd,
    handleRoutingNoResultEmailToAddChange,
    addRoutingNoResultEmail,
    removeRoutingNoResultEmailModalShow,
    resetRoutingNoResultEmails,
    hasOriginalRoutingNoResultEmailsChanged,
    setOriginalRoutingNoResultEmails,
    routingNoResultEmailOwnerNameToAdd,
    handleRoutingNoResultEmailOwnerNameToAddChange,
    setRoutingNoResultEmails,
  };
}
